import { Component, Inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MerchantService, type OdinFeatures } from '@odin/odin-core';
import { NEW_TRANSACTION_EXPERIENCE_TOGGLE } from '../../transaction-detail-page/new-transaction-detail.guard';

/**
 * AWS-style floating banner shown at the top of the transaction pages,
 * offering the new transaction experience. Shows only while the environment
 * toggle is on and the user hasn't saved a choice; either answer is persisted
 * to their UI defaults, so the banner never reappears. The choice can be
 * changed later from the profile page.
 */
@Component({
  standalone: false,
  selector: 'odin-new-experience-banner',
  templateUrl: './new-experience-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./new-experience-banner.component.scss'],
})
export class NewExperienceBannerComponent {
  public saving: boolean = false;

  constructor(
    @Inject('features') private features: OdinFeatures,
    private merchantService: MerchantService,
    private changeDetector: ChangeDetectorRef,
  ) { }

  public get visible(): boolean {
    if (!this.features[NEW_TRANSACTION_EXPERIENCE_TOGGLE]) return false;

    const profile = this.merchantService.getUserprofile();
    if (profile === null) return false;

    const preference = profile.uiDefaults?.newTransactionExperience;
    return preference === undefined || preference === null;
  }

  public choose(enabled: boolean): void {
    if (this.saving) return;
    this.saving = true;

    this.merchantService.SetUiDefaults({ newTransactionExperience: enabled }, () => {
      // the saved choice hides the banner via the visible getter
      this.saving = false;
      this.changeDetector.markForCheck();
    });
  }
}
